import {useTranslation} from 'react-i18next';
// The API reports document counts with an English code as the "unit" (MO / receipt / NCR).
// Real product units (PCS, KG…) come from the ledger and are shown as they are.
const COUNT_UNITS:Record<string,string>={MO:'mo',receipt:'receipt',NCR:'ncr',day:'day',product:'product',PI:'pi',PO:'po'};
export function kpiUnitKey(unit:string|null|undefined):string|null{
 if(!unit)return null;
 const key=COUNT_UNITS[unit];
 return key?`kpis.units.${key}`:null;
}
export function useKpiUnit(){
 const {t}=useTranslation();
 return (unit:string|null|undefined)=>{const key=kpiUnitKey(unit);return key?t(key):unit??'';};
}
